import { Component, EventEmitter, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ConfirmBySmsService } from '../../../../../shared/components/modals/confirm-by-sms/confirm-by-sms.service';
import { LoginBySmsFormValue, SmsCodeSendResponse } from '../../../../../core/modules/auth/auth.types';

export interface UserLoginData { // ИИН пользователя
  login: string; // Последние 4 цифры номера телефона, на который было отправлено смс
  smsCodeSendResponse: SmsCodeSendResponse;
}

@UntilDestroy()
@Component({
  selector: 'tax-login-by-sms-form',
  templateUrl: 'login-by-sms-form.component.html',
  styleUrls: ['login-by-sms-form.component.sass'],
})

export class LoginBySmsFormComponent {
  @Output() smsSend: EventEmitter<UserLoginData> = new EventEmitter<UserLoginData>();

  loading = false;
  loginForm: UntypedFormGroup = this.fb.group({
    login: ['', Validators.required],
  });

  constructor(
    private confirmBySmsService: ConfirmBySmsService,
    private fb: UntypedFormBuilder,
  ) {}

  sendPasswordToUserPhone(loginBySmsForm: LoginBySmsFormValue): void {
    this.loading = true;

    this.confirmBySmsService.sendPasswordToUserPhone(loginBySmsForm)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (response) => {
          this.smsSend.emit({
            login: loginBySmsForm.login, smsCodeSendResponse: response,
          });
        },
        error: () => {
          this.loading = false;
        },
      });
  }
}
